import { render, staticRenderFns } from "./ImageMultipleViewer.vue?vue&type=template&id=605bceee&scoped=true"
import script from "./ImageMultipleViewer.vue?vue&type=script&lang=js"
export * from "./ImageMultipleViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605bceee",
  null
  
)

export default component.exports